import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { useCourseStudentView } from '@/hooks/useCourseStudentView';
import { getProperty } from '@/lib/object';
import { Lesson } from '@/models/Lesson';
import PageNotFound from '@/pages/PageNotFound/PageNotFound';
import { ApplicationState } from '@/store';
import { setCurrentContent } from '@/store/item/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ContentScreen from './ContenScreen';

const LessonPage: React.FC = () => {
    const dispatch = useDispatch();

    const lessonId: number = Number(useParams<{ lessonId: string }>().lessonId);
    const courseId: number = Number(useParams<{ courseId: string }>().courseId);
    const classEnrollmentId: number = Number(useParams<{ enrollmentId: string }>().enrollmentId);

    const { content } = useSelector((state: ApplicationState) => ({
        content: state.itens.currentData.content,
    }));

    const [hasLesson, setHasLesson] = useState<boolean>(false);

    const { course, clearCourseStudentView, loading, hasError, refresh } = useCourseStudentView({
        moduleId: Constants.LMS_MODULE_ID,
        courseId,
        classEnrollmentId,
    });

    const loadOnMount = (): void => {
        if (course.id) {
            refresh();
        }
    };

    const clearAllOnUnmount = () => {
        return () => {
            clearCourseStudentView();
        };
    };

    const loadLesson = (): void => {
        if (course.lessons) {
            const lesson: Lesson | undefined = course.lessons.find((lesson: Lesson) => lesson.id === lessonId);

            if (lesson && lesson.content.id != getProperty(content, 'id', 0)) {
                setHasLesson(true);
                dispatch(setCurrentContent(lesson.content));
            }
        }
    };

    useEffect(loadOnMount, []);

    useEffect(clearAllOnUnmount, []);

    useEffect(loadLesson, [course.lessons, lessonId]);

    return (
        <>
            {loading && <Loader />}
            {!loading && hasLesson && <ContentScreen />}
            {!loading && hasError && <PageNotFound />}
        </>
    );
};

export default LessonPage;
